import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/axios";
import { TemplateDto } from "../../types/template";

export const useUpdateTemplate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }: { id: number; data: TemplateDto }) =>
            api.put(`/settings-app/templates/${id}`, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['templates'] });
        }
    });
};